import React from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../constants/styles';

function PaperClipIcon({ isFromCurrentUser }) {
    return (
        <svg
            version="1.1"
            id="Layer_1"
            fill={isFromCurrentUser ? COLORS.WHITE : COLORS.GRAY_TUNDORA}
            x="0px"
            y="0px"
            viewBox="0 0 28 25"
            xmlSpace="preserve"
        >
            <g>
                <path d="M24.8,3.2C23.4,1.8,21.4,1,19.4,1c-2,0-4,0.8-5.4,2.2L7.3,9.8l-4.6,4.6c-2.2,2.2-2.3,5.8-0.1,8C3.7,23.5,5.1,24,6.6,24c1.5,0,3-0.6,4.1-1.7l8.4-8.3c0,0,0,0,0,0l2.9-2.9c0.8-0.7,1.2-1.7,1.2-2.8c0-1.1-0.4-2.1-1.1-2.8C20.5,4,18,4,16.4,5.6L6.2,15.6c-0.3,0.3-0.3,0.8,0,1.1C6.4,16.9,6.6,17,6.8,17s0.4-0.1,0.6-0.2L17.5,6.6c1-1,2.5-1,3.4-0.1c0.4,0.4,0.7,1,0.7,1.7c0,0.6-0.3,1.3-0.7,1.7l-3,3c0,0,0,0,0,0l-8.3,8.2c-1.6,1.6-4.3,1.7-5.8,0.1c-1.6-1.6-1.5-4.2,0.1-5.8L4.3,15c0,0,0,0,0,0L15.1,4.3c1.1-1.1,2.7-1.8,4.3-1.8c1.6,0,3.1,0.6,4.3,1.7c2.4,2.3,2.3,6.2-0.1,8.5l-8.8,8.8c-0.3,0.3-0.3,0.8,0,1.1c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2l8.8-8.8C27.7,10.9,27.8,6.1,24.8,3.2z" />
            </g>
        </svg>
    );
}

PaperClipIcon.propTypes = {
    isFromCurrentUser: PropTypes.bool.isRequired,
};

export default PaperClipIcon;
